import { api } from "../AxiosInstance";

export function driverLogApi(params) {
  return api().get("/api/DriverLog/Get", {params});
}
